export default function isDev () : boolean {
  const domain = window.location.hostname
  if (domain === 'localhost' || domain.includes('192.')) return true
  return false
}
